import { SelectionData, LangState } from "./types/ui.types";
import {
  FIRM_LANGUAGE_VALUES,
  FIRM_OPTIONS_DELIMITER,
  makeOptionHelpers,
} from "@eip/shared/utils/firmProfileOptions";

// Popular languages offered by SP firms, Canadian-context. Values are
// single-sourced in @eip/shared/utils/firmProfileOptions (review R21) so the
// server validates against the exact same list this multi-select offers
// (mirrors the industriesOfFocus pattern in industryOptions.ts). Only the
// French display text lives here; the parse/serialize/display machinery comes
// from the shared makeOptionHelpers factory (C16/C31).
const LANGUAGE_FR_TEXT: Record<string, string> = {
  English: "Anglais",
  French: "Français",
  Spanish: "Espagnol",
  Mandarin: "Mandarin",
  Cantonese: "Cantonais",
  Punjabi: "Pendjabi",
  Hindi: "Hindi",
  Urdu: "Ourdou",
  Arabic: "Arabe",
  Tagalog: "Tagalog",
  Portuguese: "Portugais",
  German: "Allemand",
  Italian: "Italien",
  Other: "Autre",
};

const helpers = makeOptionHelpers(FIRM_LANGUAGE_VALUES, LANGUAGE_FR_TEXT);

export const LANGUAGE_OPTIONS: SelectionData[] = helpers.options;

// languages is stored as a single string across the stack; the firm profile
// multi-select round-trips it through this delimiter. "; " is safe because no
// language option contains it (matches INDUSTRIES_DELIMITER).
export const LANGUAGES_DELIMITER = FIRM_OPTIONS_DELIMITER;

// Tokenizes a stored languages string (review R18): comma-aware and
// case-insensitive against the canonical list, and PRESERVES unmatched legacy
// free-text tokens verbatim instead of collapsing them to "Other". Legacy
// values like "English, French" resolve to the canonical tokens; anything
// unrecognized survives a form round-trip intact. Mirrors parseIndustries.
export const parseLanguages: (value?: string) => string[] = helpers.parse;

export const serializeLanguages: (values: string[]) => string = helpers.serialize;

// ── Render-time display mapping (review R20) ─────────────────────────
// Stored values are the English canonical strings; FR mode maps them through
// frText at render time. Preserved legacy free-text tokens render verbatim.

export const displayLanguage: (token: string, lang: LangState) => string = helpers.display;

export const displayLanguages: (value: string | undefined, lang: LangState) => string =
  helpers.displayList;
